const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2E75B6', paddingBottom:'8px', marginBottom:'24px', color:'#1F3864' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#2E75B6', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2E75B6', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#EBF3FB', border:'2px solid #2E75B6', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#1F3864', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2E75B6' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#2E75B6', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#f5f9ff' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#1F3864', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#f8fbff', border:'1px solid #ccd9ea', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#1F3864', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((it, i) => <div key={i} style={S.infoBoxItem}>{it}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Formula / Notes</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Set Operations with Venn Diagrams ─────────────────
function DiagramSetOps() {
  const W = 900, H = 270;
  // 5 equal panels
  const n = 5;
  const PW = (W - 14 - (n - 1) * 10) / n;
  const p = i => 14 + i * (PW + 10);
  const r = 46, oy = 130;

  const ops = [
    { name:'Union', sym:'A ∪ B',       color:'#2E75B6', bg:'#EBF3FB',
      shade: (ox) => (
        <g>
          <circle cx={ox - 20} cy={oy} r={r} fill="#2E75B6" fillOpacity="0.45"/>
          <circle cx={ox + 20} cy={oy} r={r} fill="#2E75B6" fillOpacity="0.45"/>
        </g>
      ),
    },
    { name:'Intersection', sym:'A ∩ B', color:'#27ae60', bg:'#f0fff4',
      shade: (ox) => (
        <g>
          <defs>
            <clipPath id="cA1"><circle cx={ox - 20} cy={oy} r={r}/></clipPath>
          </defs>
          <circle cx={ox + 20} cy={oy} r={r} fill="#27ae60" fillOpacity="0.6" clipPath="url(#cA1)"/>
        </g>
      ),
    },
    { name:'Difference', sym:'A \\ B',  color:'#e07b00', bg:'#fff7ee',
      shade: (ox) => (
        <g>
          <defs>
            <clipPath id="cA2"><circle cx={ox + 20} cy={oy} r={r}/></clipPath>
          </defs>
          <circle cx={ox - 20} cy={oy} r={r} fill="#e07b00" fillOpacity="0.5"/>
          <circle cx={ox + 20} cy={oy} r={r} fill="white" fillOpacity="0.9" clipPath="url(#cA2)"/>
        </g>
      ),
    },
    { name:'Complement', sym:"A'",       color:'#c0392b', bg:'#fff0f0',
      shade: (ox) => (
        <g>
          <rect x={ox - r - 28} y={oy - r - 14} width={PW - 4} height={(r + 14) * 2}
            fill="#c0392b" fillOpacity="0.2"/>
          <circle cx={ox - 20} cy={oy} r={r} fill="white" fillOpacity="0.92"/>
        </g>
      ),
    },
    { name:'Sym. Diff.', sym:'A △ B',    color:'#9b59b6', bg:'#f5d0ff',
      shade: (ox) => (
        <g>
          <defs>
            <clipPath id="cA3"><circle cx={ox - 20} cy={oy} r={r}/></clipPath>
          </defs>
          <circle cx={ox - 20} cy={oy} r={r} fill="#9b59b6" fillOpacity="0.5"/>
          <circle cx={ox + 20} cy={oy} r={r} fill="#9b59b6" fillOpacity="0.5"/>
          <circle cx={ox + 20} cy={oy} r={r} fill="white" fillOpacity="0.88" clipPath="url(#cA3)"/>
        </g>
      ),
    },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Set Operations — Union, Intersection, Difference, Complement, Symmetric Difference</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        {ops.map(({ name, sym, color, shade }, i) => {
          const bx = p(i);
          const ox = bx + PW / 2;
          return (
            <g key={i}>
              <rect x={bx} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
              <rect x={bx} y={10} width={PW} height={28} rx={5} fill={color}/>
              <rect x={bx} y={30} width={PW} height={8} fill={color}/>
              <text x={ox} y={27} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{name}</text>
              {/* Shading */}
              {shade(ox)}
              {/* Circle outlines */}
              <circle cx={ox - 20} cy={oy} r={r} fill="none" stroke={color} strokeWidth="2"/>
              <circle cx={ox + 20} cy={oy} r={r} fill="none" stroke={color} strokeWidth="2"/>
              {/* Labels */}
              <text x={ox - r - 8} y={oy - r + 8} fontSize="13" fill={color} fontWeight="700">A</text>
              <text x={ox + r + 2} y={oy - r + 8} fontSize="13" fill={color} fontWeight="700">B</text>
              {/* Formula */}
              <text x={ox} y={H - 22} textAnchor="middle" fontSize="12" fill={color}
                fontWeight="700" fontFamily="'Courier New',monospace">{sym}</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Venn diagrams show which parts of the universe belong to each set operation. Union shades both circles; intersection only the overlap; difference shades A but erases the overlap with B; complement shades everything outside A; symmetric difference shades each circle but erases their overlap — it is equivalent to (A ∪ B) \ (A ∩ B).</div>
    </div>
  );
}

// ── Diagram 2: Set Identities ────────────────────────────────────
function DiagramSetIdentities() {
  const W = 900, H = 390;
  const PW = (W - 42) / 2;
  const pL = 14, pR = pL + PW + 14;
  const RW = W - pR - 14;

  const lawsL = [
    { name:'Commutative',   l1:'A ∪ B = B ∪ A',         l2:'A ∩ B = B ∩ A',         color:'#2E75B6', bg:'#EBF3FB', bc:'#2E75B6' },
    { name:'Associative',   l1:'(A∪B)∪C = A∪(B∪C)',    l2:'(A∩B)∩C = A∩(B∩C)',    color:'#27ae60', bg:'#f0fff4', bc:'#27ae60' },
    { name:'Distributive',  l1:'A∪(B∩C)=(A∪B)∩(A∪C)', l2:'A∩(B∪C)=(A∩B)∪(A∩C)', color:'#e07b00', bg:'#fff7ee', bc:'#e07b00' },
    { name:'Identity',      l1:'A ∪ ∅ = A',              l2:'A ∩ U = A',              color:'#9b59b6', bg:'#f5d0ff', bc:'#9b59b6' },
    { name:'Complement',    l1:"A ∪ A' = U",             l2:"A ∩ A' = ∅",            color:'#c0392b', bg:'#fff0f0', bc:'#c0392b' },
    { name:'Idempotent',    l1:'A ∪ A = A',              l2:'A ∩ A = A',              color:'#1F3864', bg:'#e8eaf6', bc:'#1F3864' },
  ];

  const lawsR = [
    { name:"De Morgan's 1", l1:"(A ∪ B)' = A' ∩ B'",   l2:'Negate union → intersect complements', color:'#c0392b', bg:'#fff0f0', bc:'#c0392b' },
    { name:"De Morgan's 2", l1:"(A ∩ B)' = A' ∪ B'",   l2:'Negate intersection → union complements', color:'#c0392b', bg:'#fff0f0', bc:'#c0392b' },
    { name:'Absorption',    l1:'A ∪ (A ∩ B) = A',       l2:'A ∩ (A ∪ B) = A',       color:'#27ae60', bg:'#f0fff4', bc:'#27ae60' },
    { name:'Double Compl.', l1:"(A')' = A",              l2:'Complement is an involution',           color:'#9b59b6', bg:'#f5d0ff', bc:'#9b59b6' },
    { name:'Domination',    l1:'A ∪ U = U',              l2:'A ∩ ∅ = ∅',             color:'#1F3864', bg:'#e8eaf6', bc:'#1F3864' },
    { name:'Cartesian Prod',l1:'A × B = {(a,b): a∈A, b∈B}', l2:'|A × B| = |A| · |B|', color:'#e07b00', bg:'#fff7ee', bc:'#e07b00' },
  ];

  const rH = 54;
  function LawBox({ x, pw, law, i }) {
    const { name, l1, l2, color, bg, bc } = law;
    const y = 36 + i * (rH + 4);
    return (
      <g>
        <rect x={x + 8} y={y} width={pw - 16} height={rH} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
        <text x={x + 16} y={y + 16} fontSize="11" fill={color} fontWeight="700">{name}</text>
        <text x={x + 16} y={y + 32} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">{l1}</text>
        <text x={x + 16} y={y + 48} fontSize="10" fill="#555" fontFamily="'Courier New',monospace">{l2}</text>
      </g>
    );
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Set Identities — De Morgan, Distributive, Absorption, and Structural Laws</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <rect x={pL} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={pL + PW / 2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Fundamental Laws (dual pairs)</text>
        {lawsL.map((law, i) => <LawBox key={i} x={pL} pw={PW} law={law} i={i}/>)}

        <rect x={pR} y={10} width={RW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={pR + RW / 2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Structural Laws</text>
        {lawsR.map((law, i) => <LawBox key={i} x={pR} pw={RW} law={law} i={i}/>)}
      </svg>
      <div style={S.dCaption}>Set algebra is dual: every law has a twin obtained by swapping ∪ with ∩ and ∅ with U. De Morgan's laws are the most important: the complement of a union is the intersection of complements, and vice versa. The distributive laws differ from arithmetic — both ∪ over ∩ and ∩ over ∪ distribute. The Cartesian product A × B produces all ordered pairs; its size is the product of the individual sizes.</div>
    </div>
  );
}

// ── Diagram 3: Functions and Relations ──────────────────────────
function DiagramFunctions() {
  const W = 900, H = 320;
  const n = 3;
  const PW = (W - 14 - (n - 1) * 14) / n;
  const px = i => 14 + i * (PW + 14);
  const RW = W - (px(2)) - 14;

  // Mapping diagram helper
  function MapDiag({ ox, domY, domain, codomain, arrows, color, bg, bc, note }) {
    const domX = ox + 44, codX = ox + PW - 52;
    const nodeR = 14;
    const rowH = 38;
    return (
      <g>
        {/* Domain column */}
        <text x={domX} y={domY - 14} textAnchor="middle" fontSize="10" fill={color} fontWeight="700">Domain</text>
        {domain.map((lbl, i) => (
          <g key={'d' + i}>
            <circle cx={domX} cy={domY + i * rowH} r={nodeR} fill={bg} stroke={color} strokeWidth="1.8"/>
            <text x={domX} y={domY + i * rowH + 4} textAnchor="middle" fontSize="12" fill={color}
              fontWeight="700" fontFamily="'Courier New',monospace">{lbl}</text>
          </g>
        ))}
        {/* Codomain column */}
        <text x={codX} y={domY - 14} textAnchor="middle" fontSize="10" fill={color} fontWeight="700">Codomain</text>
        {codomain.map((lbl, i) => (
          <g key={'c' + i}>
            <circle cx={codX} cy={domY + i * rowH} r={nodeR} fill={bg} stroke={color} strokeWidth="1.8"
              strokeDasharray={lbl === '—' ? '3,2' : undefined}/>
            <text x={codX} y={domY + i * rowH + 4} textAnchor="middle" fontSize="12" fill={color}
              fontWeight="700" fontFamily="'Courier New',monospace">{lbl !== '—' ? lbl : ''}</text>
          </g>
        ))}
        {/* Arrows */}
        {arrows.map(([di, ci], ai) => {
          const x1 = domX + nodeR + 2, y1 = domY + di * rowH;
          const x2 = codX - nodeR - 2, y2 = domY + ci * rowH;
          const dx = x2 - x1, dy = y2 - y1, len = Math.sqrt(dx*dx+dy*dy);
          if (len < 1) return null;
          const ux = dx/len, uy = dy/len;
          const hx = x2 - 7*ux, hy = y2 - 7*uy;
          return (
            <g key={ai}>
              <line x1={x1} y1={y1} x2={hx} y2={hy} stroke={color} strokeWidth="1.6"/>
              <polygon points={`${x2},${y2} ${hx+4*(-uy)},${hy+4*ux} ${hx-4*(-uy)},${hy-4*ux}`} fill={color}/>
            </g>
          );
        })}
        {/* Note */}
        <text x={ox + PW/2} y={domY + codomain.length * rowH + 10} textAnchor="middle"
          fontSize="10" fill={color}>{note}</text>
      </g>
    );
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Functions — Injective, Surjective, Bijective; Relations and Their Properties</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Panel 0: Injective (one-to-one) */}
        <rect x={px(0)} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <rect x={px(0)} y={10} width={PW} height={28} rx={5} fill="#2E75B6"/>
        <rect x={px(0)} y={30} width={PW} height={8} fill="#2E75B6"/>
        <text x={px(0)+PW/2} y={27} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">Injective (1-to-1)</text>
        <MapDiag ox={px(0)} domY={62} domain={['a','b','c']} codomain={['1','2','3','4']}
          arrows={[[0,0],[1,2],[2,3]]} color="#2E75B6" bg="#EBF3FB" bc="#2E75B6"
          note="No two inputs map to same output"/>
        <rect x={px(0)+8} y={H-66} width={PW-16} height={50} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={px(0)+16} y={H-52} fontSize="10" fill="#1F3864" fontWeight="700">f(a)=f(b) implies a=b</text>
        <text x={px(0)+16} y={H-38} fontSize="10" fill="#444">Distinct inputs → distinct outputs</text>
        <text x={px(0)+16} y={H-24} fontSize="10" fill="#555">Range may be smaller than codomain</text>

        {/* Panel 1: Surjective (onto) */}
        <rect x={px(1)} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <rect x={px(1)} y={10} width={PW} height={28} rx={5} fill="#27ae60"/>
        <rect x={px(1)} y={30} width={PW} height={8} fill="#27ae60"/>
        <text x={px(1)+PW/2} y={27} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">Surjective (onto)</text>
        <MapDiag ox={px(1)} domY={62} domain={['a','b','c','d']} codomain={['1','2','3']}
          arrows={[[0,0],[1,0],[2,1],[3,2]]} color="#27ae60" bg="#f0fff4" bc="#27ae60"
          note="Every output has at least one input"/>
        <rect x={px(1)+8} y={H-66} width={PW-16} height={50} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={px(1)+16} y={H-52} fontSize="10" fill="#1a6640" fontWeight="700">Range = Codomain</text>
        <text x={px(1)+16} y={H-38} fontSize="10" fill="#444">Every output is hit at least once</text>
        <text x={px(1)+16} y={H-24} fontSize="10" fill="#555">Multiple inputs may map to same output</text>

        {/* Panel 2: Bijective + relation types */}
        <rect x={px(2)} y={10} width={RW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <rect x={px(2)} y={10} width={RW} height={28} rx={5} fill="#9b59b6"/>
        <rect x={px(2)} y={30} width={RW} height={8} fill="#9b59b6"/>
        <text x={px(2)+RW/2} y={27} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">Bijective (1-to-1 and onto) + Relation Types</text>
        <MapDiag ox={px(2)} domY={62} domain={['a','b','c']} codomain={['1','2','3']}
          arrows={[[0,2],[1,0],[2,1]]} color="#9b59b6" bg="#f5d0ff" bc="#9b59b6"
          note="Perfect pairing — invertible"/>
        {/* Relation properties */}
        {[
          { y:224, color:'#2E75B6', bg:'#EBF3FB', bc:'#2E75B6',
            name:'Reflexive', def:'aRa for all a ∈ A' },
          { y:256, color:'#27ae60', bg:'#f0fff4', bc:'#27ae60',
            name:'Symmetric', def:'aRb implies bRa' },
          { y:288, color:'#e07b00', bg:'#fff7ee', bc:'#e07b00',
            name:'Transitive', def:'aRb and bRc implies aRc' },
        ].map(({ y, color, bg, bc, name, def }) => (
          <g key={y}>
            <rect x={px(2)+8} y={y} width={RW-16} height={26} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={px(2)+16} y={y+12} fontSize="10" fill={color} fontWeight="700">{name}:</text>
            <text x={px(2)+90} y={y+12} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{def}</text>
          </g>
        ))}
        <text x={px(2)+16} y={H-12} fontSize="10" fill="#9b59b6" fontWeight="700">Equivalence relation = Reflexive + Symmetric + Transitive</text>
      </svg>
      <div style={S.dCaption}>A function f: A→B assigns each element of A exactly one element of B. Injective (one-to-one): distinct inputs give distinct outputs. Surjective (onto): every element of the codomain is an output. Bijective: both — a perfect pairing enabling an inverse function. A relation on A is an equivalence relation if it is reflexive, symmetric, and transitive; equivalence relations partition A into equivalence classes.</div>
    </div>
  );
}

// ── Diagram 4: Cardinality & Infinity ───────────────────────────
function DiagramCardinality() {
  const W = 900, H = 340;
  const LP = 14, LW = 420;
  const RP = LP + LW + 14, RW = W - RP - 14;

  // Left: number sets hierarchy (nested ovals) + cardinality comparisons
  // Right: Cantor diagonal argument sketch for uncountability of (0,1)

  // Nested ovals: ℕ inside ℤ inside ℚ inside ℝ inside ℂ
  const sets = [
    { rx:40,  ry:22,  label:'ℕ', sublabel:'Naturals',   color:'#2E75B6', desc:'0,1,2,3...' },
    { rx:80,  ry:44,  label:'ℤ', sublabel:'Integers',   color:'#27ae60', desc:'...-1,0,1...' },
    { rx:128, ry:66,  label:'ℚ', sublabel:'Rationals',  color:'#e07b00', desc:'p/q form' },
    { rx:178, ry:90,  label:'ℝ', sublabel:'Reals',      color:'#c0392b', desc:'includes irrationals' },
    { rx:196, ry:102, label:'ℂ', sublabel:'Complex',    color:'#9b59b6', desc:'a+bi' },
  ];
  const cx = LP + LW / 2 + 10, cy = 145;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Cardinality — Finite Sets, Countably Infinite ℕ/ℤ/ℚ, and Uncountably Infinite ℝ</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Left panel */}
        <rect x={LP} y={10} width={LW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={LP+LW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Number Sets and Their Cardinalities</text>

        {/* Nested ovals — draw outermost first */}
        {[...sets].reverse().map(({ rx: rx2, ry: ry2, color }, i) => (
          <ellipse key={i} cx={cx} cy={cy} rx={rx2} ry={ry2}
            fill="none" stroke={color} strokeWidth="2"/>
        ))}

        {/* Labels inside at appropriate positions */}
        {sets.map(({ rx: rx2, ry: ry2, label, sublabel, color, desc }, i) => {
          const lx = cx - rx2 + 10;
          const ly = cy - ry2 + 14;
          return (
            <g key={i}>
              <text x={lx} y={ly} fontSize="13" fill={color} fontWeight="700"
                fontFamily="'Courier New',monospace">{label}</text>
              <text x={lx + 16} y={ly} fontSize="9" fill={color}>{sublabel}</text>
              {i > 0 && (
                <text x={lx + 2} y={ly + 12} fontSize="8" fill={color + 'aa'}>{desc}</text>
              )}
            </g>
          );
        })}

        {/* Cardinality table */}
        <rect x={LP+10} y={215} width={LW-20} height={106} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={LP+18} y={231} fontSize="11" fill="#1F3864" fontWeight="700">Cardinality comparison:</text>

        {[
          { set:'|A| = n (finite)',   size:'n',    card:'Finite',           color:'#2E75B6' },
          { set:'|ℕ| = |ℤ| = |ℚ|',  size:'ℵ₀',   card:'Countably infinite',color:'#27ae60' },
          { set:'|ℝ| = |(0,1)|',     size:'c = 2^ℵ₀', card:'Uncountably infinite', color:'#c0392b' },
          { set:'|P(A)| = 2^|A|',    size:'Cantor: always strictly larger', card:'', color:'#9b59b6' },
        ].map(({ set: setStr, size, card, color }, i) => (
          <g key={i}>
            <text x={LP+18} y={248+i*18} fontSize="10" fill={color}
              fontFamily="'Courier New',monospace" fontWeight="700">{setStr}</text>
            <text x={LP+18+200} y={248+i*18} fontSize="10" fill="#444"
              fontFamily="'Courier New',monospace">{size}  {card}</text>
          </g>
        ))}

        {/* Right panel: Cantor diagonal */}
        <rect x={RP} y={10} width={RW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={RP+RW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Cantor's Diagonal Argument</text>
        <text x={RP+RW/2} y={44} textAnchor="middle" fontSize="11" fill="#c0392b">Proves ℝ is uncountable (|ℝ| &gt; ℵ₀)</text>

        {/* Suppose we list all reals in (0,1) as an infinite list */}
        <text x={RP+14} y={64} fontSize="11" fill="#333">Suppose all reals in (0,1) could be listed:</text>

        {/* Show a fake enumeration with diagonal highlighted */}
        {[
          ['r₁', '0.', [4,1,5,9,2]],
          ['r₂', '0.', [8,2,8,1,8]],
          ['r₃', '0.', [3,3,3,0,1]],
          ['r₄', '0.', [7,6,5,3,5]],
          ['r₅', '0.', [0,2,9,4,4]],
        ].map(([label, prefix, digits], ri) => {
          const y = 82 + ri * 22;
          return (
            <g key={ri}>
              <text x={RP+14} y={y} fontSize="11" fill="#555"
                fontFamily="'Courier New',monospace">{label} = {prefix}</text>
              {digits.map((d, di) => {
                const isDiag = di === ri;
                const x = RP + 78 + di * 18;
                return (
                  <g key={di}>
                    {isDiag && (
                      <rect x={x - 5} y={y - 13} width={16} height={17} rx={2}
                        fill="#c0392b" fillOpacity="0.18" stroke="#c0392b" strokeWidth="1.5"/>
                    )}
                    <text x={x} y={y} fontSize="11" fill={isDiag ? '#c0392b' : '#444'}
                      fontWeight={isDiag ? '700' : '400'}
                      fontFamily="'Courier New',monospace">{d}</text>
                  </g>
                );
              })}
            </g>
          );
        })}

        {/* New number */}
        <line x1={RP+10} y1={196} x2={RP+RW-10} y2={196} stroke="#c0392b" strokeWidth="1" strokeDasharray="4,3"/>
        <text x={RP+14} y={212} fontSize="11" fill="#c0392b" fontWeight="700">
          Construct d: flip each diagonal digit:
        </text>
        <text x={RP+14} y={228} fontSize="11" fill="#c0392b"
          fontFamily="'Courier New',monospace">d = 0. 5 3 4 4 5 ...</text>
        <text x={RP+14} y={244} fontSize="11" fill="#333">(each digit differs from diagonal digit)</text>

        <rect x={RP+10} y={256} width={RW-20} height={66} rx={3} fill="#fff0f0" stroke="#c0392b" strokeWidth="1"/>
        <text x={RP+18} y={272} fontSize="11" fill="#c0392b" fontWeight="700">d differs from every rᵢ in the i-th digit</text>
        <text x={RP+18} y={288} fontSize="11" fill="#444">So d is NOT in the list — contradiction!</text>
        <text x={RP+18} y={304} fontSize="11" fill="#333">Therefore no such listing exists: ℝ is uncountable.</text>
        <text x={RP+18} y={318} fontSize="10" fill="#555">|ℝ| = c = 2^ℵ₀  (cardinality of the continuum)</text>

      </svg>
      <div style={S.dCaption}>Cantor showed that the natural numbers ℕ, integers ℤ, and rationals ℚ all have the same cardinality ℵ₀ (countably infinite), while the real numbers ℝ are strictly larger (uncountably infinite, cardinality c = 2^ℵ₀). The diagonal argument constructs a real number that differs from every member of any proposed enumeration of (0,1), proving no bijection from ℕ to ℝ can exist. Cantor's theorem generalises: |P(A)| &gt; |A| for any set A.</div>
    </div>
  );
}

// ── Diagram 5: Divisibility & Euclidean Algorithm ───────────────
function DiagramDivisibility() {
  const W = 900, H = 360;
  const LP = 14, LW = 390;
  const RP = LP + LW + 14, RW = W - RP - 14;

  // Left: divisors of 48 shown as a factor lattice (partial)
  // Use a simple bar / grid of divisors
  const divs48 = [1,2,3,4,6,8,12,16,24,48];

  // Euclidean algorithm: gcd(48, 18)
  // 48 = 2*18 + 12
  // 18 = 1*12 + 6
  // 12 = 2*6  + 0  → gcd = 6
  const euclidSteps = [
    { a:48, b:18, q:2, r:12 },
    { a:18, b:12, q:1, r:6  },
    { a:12, b:6,  q:2, r:0  },
  ];

  // Bezout: 6 = 18 - 1*12 = 18 - 1*(48 - 2*18) = 3*18 - 1*48
  // So gcd(48,18) = (-1)*48 + 3*18

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Divisibility — Divisors of 48, Euclidean Algorithm for GCD, and Bézout's Identity</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Left panel */}
        <rect x={LP} y={10} width={LW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={LP+LW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Divisors and Divisibility</text>

        {/* Divisors of 48 as colored tiles */}
        <text x={LP+14} y={48} fontSize="12" fill="#1F3864" fontWeight="700">Divisors of 48:</text>
        {divs48.map((d, i) => {
          const row = Math.floor(i / 5);
          const col = i % 5;
          const tx = LP + 14 + col * 72;
          const ty = 56 + row * 36;
          const is48 = d === 48;
          const isPrime = [2,3].includes(d);
          const color = is48 ? '#c0392b' : isPrime ? '#27ae60' : '#2E75B6';
          const bg = is48 ? '#fff0f0' : isPrime ? '#f0fff4' : '#EBF3FB';
          return (
            <g key={i}>
              <rect x={tx} y={ty} width={64} height={28} rx={3} fill={bg} stroke={color} strokeWidth="1.5"/>
              <text x={tx+32} y={ty+18} textAnchor="middle" fontSize="13" fill={color}
                fontWeight="700" fontFamily="'Courier New',monospace">{d}</text>
            </g>
          );
        })}

        {/* Divisibility facts */}
        <text x={LP+14} y={136} fontSize="11" fill="#1F3864" fontWeight="700">Key definitions:</text>
        {[
          { t:'a | b  (a divides b): ∃k ∈ ℤ, b = ka', c:'#2E75B6' },
          { t:'gcd(a,b): largest integer dividing both a and b', c:'#27ae60' },
          { t:'lcm(a,b): smallest positive multiple of both', c:'#e07b00' },
          { t:'gcd(a,b) · lcm(a,b) = a · b', c:'#9b59b6' },
        ].map(({ t, c }, i) => (
          <text key={i} x={LP+14} y={152+i*18} fontSize="10.5" fill={c}
            fontFamily="'Courier New',monospace">{t}</text>
        ))}

        {/* Euclidean algorithm steps */}
        <rect x={LP+10} y={228} width={LW-20} height={114} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5"/>
        <text x={LP+18} y={244} fontSize="12" fill="#27ae60" fontWeight="700">Euclidean Algorithm: gcd(48, 18)</text>
        <text x={LP+18} y={260} fontSize="10" fill="#555">Repeatedly replace (a,b) with (b, a mod b) until b = 0</text>
        {euclidSteps.map(({ a, b, q, r }, i) => {
          const isLast = r === 0;
          return (
            <g key={i}>
              <text x={LP+18} y={278+i*22} fontSize="11" fill={isLast?'#c0392b':'#333'}
                fontFamily="'Courier New',monospace" fontWeight={isLast?'700':'400'}>
                {a} = {q} × {b} + {r}{isLast ? '  ← gcd = ' + b : ''}
              </text>
            </g>
          );
        })}
        <text x={LP+18} y={344} fontSize="10.5" fill="#9b59b6" fontFamily="'Courier New',monospace">
          Bézout: 6 = 3×18 + (-1)×48  (gcd = linear combo)
        </text>

        {/* Right panel */}
        <rect x={RP} y={10} width={RW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={RP+RW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Euclidean Algo Flow</text>

        {/* Flow diagram */}
        {[
          { y:44,  label:'Start: (a, b) = (48, 18)', color:'#2E75B6', bg:'#EBF3FB', bc:'#2E75B6', w:RW-24 },
          { y:92,  label:'48 = 2×18 + 12  →  (18, 12)', color:'#27ae60', bg:'#f0fff4', bc:'#27ae60', w:RW-24 },
          { y:140, label:'18 = 1×12 + 6   →  (12, 6)',  color:'#e07b00', bg:'#fff7ee', bc:'#e07b00', w:RW-24 },
          { y:188, label:'12 = 2×6  + 0   →  stop!',   color:'#c0392b', bg:'#fff0f0', bc:'#c0392b', w:RW-24 },
        ].map(({ y, label, color, bg, bc, w }) => (
          <g key={y}>
            <rect x={RP+12} y={y} width={w} height={36} rx={4} fill={bg} stroke={bc} strokeWidth="1.5"/>
            <text x={RP+20} y={y+14} fontSize="11" fill={color} fontWeight="700"
              fontFamily="'Courier New',monospace">{label}</text>
            <text x={RP+20} y={y+28} fontSize="10" fill="#555">remainder = {[12,6,0,''][Math.floor((y-44)/48)]}</text>
          </g>
        ))}
        {[92,140,188].map(y => (
          <g key={y}>
            <line x1={RP+RW/2} y1={y-4} x2={RP+RW/2} y2={y} stroke="#888" strokeWidth="1.5"/>
            <polygon points={`${RP+RW/2},${y} ${RP+RW/2-5},${y-8} ${RP+RW/2+5},${y-8}`} fill="#888"/>
          </g>
        ))}

        {/* Result + Bezout */}
        <rect x={RP+12} y={240} width={RW-24} height={100} rx={3} fill="#e8eaf6" stroke="#1F3864" strokeWidth="1.5"/>
        <text x={RP+20} y={256} fontSize="12" fill="#1F3864" fontWeight="700">gcd(48, 18) = 6</text>
        <text x={RP+20} y={272} fontSize="11" fill="#9b59b6" fontWeight="700">Bézout's Identity:</text>
        <text x={RP+20} y={288} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">gcd(a,b) = sa + tb</text>
        <text x={RP+20} y={304} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">6 = (-1)×48 + 3×18</text>
        <text x={RP+20} y={320} fontSize="10" fill="#555">s and t found by back-substitution</text>
        <text x={RP+20} y={334} fontSize="10" fill="#555">Used to solve linear Diophantine equations</text>

      </svg>
      <div style={S.dCaption}>The Euclidean algorithm computes gcd(a,b) by repeatedly replacing (a,b) with (b, a mod b) until the remainder is 0 — the last nonzero remainder is the gcd. It runs in O(log(min(a,b))) steps. Bézout's identity guarantees integers s,t exist with gcd(a,b) = sa+tb; these can be found by back-substituting through the algorithm steps (extended Euclidean algorithm), and are used to solve modular inverse and Diophantine equations.</div>
    </div>
  );
}

// ── Diagram 6: Modular Arithmetic ────────────────────────────────
function DiagramModular() {
  const W = 900, H = 350;
  const LP = 14, LW = 320;
  const MP = LP + LW + 14, MW = 260;
  const RP = MP + MW + 14, RW = W - RP - 14;

  // Left: clock diagram mod 12
  const clkCx = LP + LW / 2, clkCy = 155, clkR = 90;
  const clkNums = [12,1,2,3,4,5,6,7,8,9,10,11];

  // Middle: congruence class table mod 5
  const mod5 = [0,1,2,3,4].map(r => ({
    cls: r,
    members: [-5+r, r, 5+r, 10+r].map(v => v >= -5 ? v : null).filter(v => v !== null),
  }));

  const clrs5 = ['#2E75B6','#27ae60','#e07b00','#c0392b','#9b59b6'];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Modular Arithmetic — Congruence Classes, Clock Arithmetic, and CRT</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Left: clock */}
        <rect x={LP} y={10} width={LW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={LP+LW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Clock Arithmetic (mod 12)</text>
        <text x={LP+LW/2} y={44} textAnchor="middle" fontSize="11" fill="#555">Example: 9 + 5 = 14 ≡ 2 (mod 12)</text>

        <circle cx={clkCx} cy={clkCy} r={clkR} fill="#f8fbff" stroke="#2E75B6" strokeWidth="2"/>
        <circle cx={clkCx} cy={clkCy} r={4} fill="#2E75B6"/>

        {clkNums.map((n, i) => {
          const angle = (i * 2 * Math.PI / 12) - Math.PI / 2;
          const tx = clkCx + (clkR - 18) * Math.cos(angle);
          const ty = clkCy + (clkR - 18) * Math.sin(angle);
          return (
            <text key={i} x={tx} y={ty + 4} textAnchor="middle" fontSize="13"
              fill={n===9||n===5||n===2?'#c0392b':'#1F3864'}
              fontWeight={n===9||n===5||n===2?'700':'400'}
              fontFamily="'Courier New',monospace">{n === 12 ? '0' : n}</text>
          );
        })}

        {/* Arrow showing 9→14≡2 */}
        {(() => {
          const a9 = (8 * 2 * Math.PI / 12) - Math.PI / 2; // position 9 on clock
          const a2 = (1 * 2 * Math.PI / 12) - Math.PI / 2; // position 2 on clock
          const x9 = clkCx + (clkR - 36) * Math.cos(a9);
          const y9 = clkCy + (clkR - 36) * Math.sin(a9);
          const x2 = clkCx + (clkR - 36) * Math.cos(a2);
          const y2 = clkCy + (clkR - 36) * Math.sin(a2);
          return (
            <path d={`M ${x9} ${y9} A ${clkR-36} ${clkR-36} 0 1 1 ${x2} ${y2}`}
              fill="none" stroke="#c0392b" strokeWidth="2" strokeDasharray="5,3"/>
          );
        })()}
        <text x={clkCx} y={clkCy + 20} textAnchor="middle" fontSize="11"
          fill="#c0392b" fontWeight="700">+5 steps</text>

        {/* Congruence definition */}
        <rect x={LP+10} y={260} width={LW-20} height={66} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={LP+18} y={276} fontSize="11" fill="#1F3864" fontWeight="700">a ≡ b (mod n)  iff  n | (a - b)</text>
        <text x={LP+18} y={292} fontSize="10" fill="#444">Equivalently: a and b have the same remainder when divided by n</text>
        <text x={LP+18} y={308} fontSize="10" fill="#444">Congruence is an equivalence relation on ℤ</text>
        <text x={LP+18} y={322} fontSize="10" fill="#555">ℤ/nℤ = {'{'}[0],[1],...,[n-1]{'}'} (n congruence classes)</text>

        {/* Middle: congruence classes mod 5 */}
        <rect x={MP} y={10} width={MW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={MP+MW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Congruence Classes mod 5</text>

        {mod5.map(({ cls, members }, i) => {
          const y = 44 + i * 52;
          const color = clrs5[i];
          return (
            <g key={i}>
              <rect x={MP+10} y={y} width={MW-20} height={44} rx={3}
                fill={color + '22'} stroke={color} strokeWidth="1.5"/>
              <text x={MP+18} y={y+16} fontSize="12" fill={color} fontWeight="700"
                fontFamily="'Courier New',monospace">[{cls}]₅ =</text>
              <text x={MP+58} y={y+16} fontSize="11" fill="#333"
                fontFamily="'Courier New',monospace">
                {'{'}{members.join(', ')}, ...{'}'}
              </text>
              <text x={MP+18} y={y+34} fontSize="10" fill={color}>
                {'{'} ...n ∈ ℤ : n ≡ {cls} (mod 5) {'}'}
              </text>
            </g>
          );
        })}

        {/* Arithmetic mod 5 note */}
        <rect x={MP+10} y={44+5*52+4} width={MW-20} height={36} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={MP+18} y={44+5*52+18} fontSize="10" fill="#1F3864" fontWeight="700">Arithmetic preserves congruence:</text>
        <text x={MP+18} y={44+5*52+32} fontSize="10" fill="#444">a≡a', b≡b' → a+b ≡ a'+b' and ab ≡ a'b'</text>

        {/* Right: CRT */}
        <rect x={RP} y={10} width={RW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={RP+RW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Chinese Remainder Theorem</text>

        <rect x={RP+10} y={36} width={RW-20} height={60} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={RP+18} y={52} fontSize="11" fill="#1F3864" fontWeight="700">If n₁,n₂,...,nₖ are pairwise coprime,</text>
        <text x={RP+18} y={67} fontSize="11" fill="#333">the system x ≡ aᵢ (mod nᵢ) has a</text>
        <text x={RP+18} y={82} fontSize="11" fill="#333">unique solution mod N = n₁n₂...nₖ.</text>

        {/* Example: x≡2(mod3), x≡3(mod5) → x≡8(mod15) */}
        <text x={RP+14} y={112} fontSize="12" fill="#e07b00" fontWeight="700">Example:</text>
        {[
          'x ≡ 2  (mod 3)',
          'x ≡ 3  (mod 5)',
          '─────────────',
          'x ≡ 8  (mod 15)',
        ].map((line, i) => (
          <text key={i} x={RP+18} y={128+i*20} fontSize="12" fill={i===3?'#c0392b':'#333'}
            fontFamily="'Courier New',monospace" fontWeight={i===3?'700':'400'}>{line}</text>
        ))}

        {/* Check: 8 mod 3 = 2 ✓, 8 mod 5 = 3 ✓ */}
        <text x={RP+14} y={216} fontSize="10" fill="#27ae60">Check: 8 mod 3 = 2 ✓  and  8 mod 5 = 3 ✓</text>

        {/* Applications */}
        {[
          { y:228, bg:'#f0fff4', bc:'#27ae60', color:'#27ae60',
            t:'RSA cryptography', n:'Uses modular exponentiation and CRT' },
          { y:270, bg:'#fff7ee', bc:'#e07b00', color:'#e07b00',
            t:'Hash functions', n:'Modular reduction gives uniform distribution' },
          { y:312, bg:'#f5d0ff', bc:'#9b59b6', color:'#9b59b6',
            t:'Computer arithmetic', n:'CRT speeds up big-number computation' },
        ].map(({ y, bg, bc, color, t, n }) => (
          <g key={y}>
            <rect x={RP+10} y={y} width={RW-20} height={36} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={RP+18} y={y+14} fontSize="11" fill={color} fontWeight="700">{t}</text>
            <text x={RP+18} y={y+28} fontSize="10" fill="#555">{n}</text>
          </g>
        ))}

      </svg>
      <div style={S.dCaption}>Modular arithmetic treats integers as members of congruence classes: a ≡ b (mod n) whenever n divides (a−b). Congruence classes form the ring ℤ/nℤ; when n is prime this ring is a field, enabling division. The Chinese Remainder Theorem guarantees a unique simultaneous solution modulo the product of pairwise coprime moduli — the foundation of RSA encryption and efficient big-integer arithmetic.</div>
    </div>
  );
}

// ── Diagram 7: Primes & Fundamental Theorem of Arithmetic ───────
function DiagramPrimes() {
  const W = 900, H = 370;
  const LP = 14, LW = 380;
  const RP = LP + LW + 14, RW = W - RP - 14;

  // Left: Sieve of Eratosthenes on 2..50
  const nums = Array.from({ length: 49 }, (_, i) => i + 2);
  const sieve = new Array(51).fill(true);
  sieve[0] = sieve[1] = false;
  for (let i = 2; i <= 50; i++) {
    if (sieve[i]) {
      for (let j = i * i; j <= 50; j += i) sieve[j] = false;
    }
  }
  const cols = 10;
  const cw = (LW - 28) / cols;
  const ch = 28;

  // Prime factorization trees
  const trees = [
    { n:60,  color:'#2E75B6', factors:'60 = 2² × 3 × 5' },
    { n:84,  color:'#27ae60', factors:'84 = 2² × 3 × 7' },
    { n:100, color:'#e07b00', factors:'100 = 2² × 5²'   },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Primes — Sieve of Eratosthenes, Prime Factorization, and Fundamental Theorem of Arithmetic</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Left: sieve */}
        <rect x={LP} y={10} width={LW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={LP+LW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Sieve of Eratosthenes (2–50)</text>
        <text x={LP+LW/2} y={44} textAnchor="middle" fontSize="10.5" fill="#555">Cross out multiples of each prime; remaining numbers are prime</text>

        {nums.map((n, i) => {
          const row = Math.floor(i / cols);
          const col = i % cols;
          const tx = LP + 14 + col * cw;
          const ty = 52 + row * ch;
          const isPrime = sieve[n];
          return (
            <g key={n}>
              <rect x={tx} y={ty} width={cw - 2} height={ch - 2} rx={2}
                fill={isPrime ? '#EBF3FB' : '#f9f9f9'}
                stroke={isPrime ? '#2E75B6' : '#e0e0e0'}
                strokeWidth={isPrime ? 1.5 : 0.8}/>
              <text x={tx + (cw - 2) / 2} y={ty + 16} textAnchor="middle" fontSize="12"
                fill={isPrime ? '#2E75B6' : '#ccc'}
                fontWeight={isPrime ? '700' : '400'}
                fontFamily="'Courier New',monospace">{n}</text>
            </g>
          );
        })}

        {/* Prime count */}
        <rect x={LP+10} y={54+5*ch+4} width={LW-20} height={54} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={LP+18} y={54+5*ch+20} fontSize="11" fill="#1F3864" fontWeight="700">
          Primes up to 50: 2,3,5,7,11,13,17,19,23,29,31,37,41,43,47  (15 primes)
        </text>
        <text x={LP+18} y={54+5*ch+36} fontSize="10" fill="#444">
          Prime counting function π(x) ≈ x / ln(x)  (Prime Number Theorem)
        </text>
        <text x={LP+18} y={54+5*ch+50} fontSize="10" fill="#555">
          Infinitely many primes (Euclid's proof by contradiction)
        </text>

        {/* Right panel */}
        <rect x={RP} y={10} width={RW} height={H - 20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={RP+RW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Fundamental Theorem of Arithmetic</text>

        {/* FTA statement */}
        <rect x={RP+10} y={36} width={RW-20} height={54} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="2"/>
        <text x={RP+18} y={52} fontSize="11" fill="#1F3864" fontWeight="700">Every integer n &gt; 1 has a unique prime</text>
        <text x={RP+18} y={68} fontSize="11" fill="#1F3864" fontWeight="700">factorisation (up to order of factors).</text>
        <text x={RP+18} y={84} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">n = p₁^a₁ · p₂^a₂ · ... · pₖ^aₖ</text>

        {/* Three factorisation trees — simplified as text trees */}
        {trees.map(({ n: num, color, factors }, i) => {
          const bx = RP + 10 + i * ((RW - 20) / 3);
          const bw = (RW - 20) / 3 - 4;
          const by = 100;

          // Draw a simple branching tree for factorisation
          const configs = [
            // 60 = 2*30 = 2*2*15 = 2*2*3*5
            { levels: [[num], [2, num/2], [2, 2, num/4], [2, 2, 3, 5]] },
            // 84 = 2*42 = 2*2*21 = 2*2*3*7
            { levels: [[num], [2, num/2], [2, 2, num/4], [2, 2, 3, 7]] },
            // 100 = 2*50 = 2*2*25 = 2*2*5*5
            { levels: [[num], [2, num/2], [2, 2, num/4], [2, 2, 5, 5]] },
          ];
          const levels = configs[i].levels;
          const levelH = 34;

          return (
            <g key={i}>
              <rect x={bx} y={by-2} width={bw} height={H-by-18} rx={3}
                fill={color + '18'} stroke={color} strokeWidth="1"/>
              {levels.map((lvl, li) => {
                const y = by + li * levelH + 14;
                const itemW = bw / lvl.length;
                return lvl.map((v, vi) => {
                  const x = bx + vi * itemW + itemW / 2;
                  const isPrimeFactor = [2,3,5,7].includes(v) && li > 0;
                  // Draw line to parent
                  if (li > 0) {
                    // Find parent index (rough: parent at floor(vi/2) if branching by 2)
                    const prevLvl = levels[li - 1];
                    const prevItemW = bw / prevLvl.length;
                    const parentIdx = Math.min(Math.floor(vi / (lvl.length / prevLvl.length)), prevLvl.length - 1);
                    const px2 = bx + parentIdx * prevItemW + prevItemW / 2;
                    const py2 = by + (li - 1) * levelH + 14;
                    return (
                      <g key={`${li}-${vi}`}>
                        <line x1={px2} y1={py2 + 8} x2={x} y2={y - 8}
                          stroke={color} strokeWidth="1.2" opacity="0.6"/>
                        <circle cx={x} cy={y} r={13}
                          fill={isPrimeFactor ? color : '#fff'}
                          stroke={color} strokeWidth="1.5"/>
                        <text x={x} y={y + 4} textAnchor="middle" fontSize="11"
                          fill={isPrimeFactor ? '#fff' : color}
                          fontWeight="700" fontFamily="'Courier New',monospace">{v}</text>
                      </g>
                    );
                  }
                  return (
                    <g key={`${li}-${vi}`}>
                      <circle cx={x} cy={y} r={14}
                        fill={color} stroke={color} strokeWidth="1.5"/>
                      <text x={x} y={y + 4} textAnchor="middle" fontSize="11"
                        fill="#fff" fontWeight="700" fontFamily="'Courier New',monospace">{v}</text>
                    </g>
                  );
                });
              })}
              <text x={bx + bw/2} y={H - 18} textAnchor="middle" fontSize="10"
                fill={color} fontWeight="700" fontFamily="'Courier New',monospace">{factors}</text>
            </g>
          );
        })}

        {/* GCD/LCM from factorizations */}
        <rect x={RP+10} y={H-62} width={RW-20} height={48} rx={3} fill="#f5d0ff" stroke="#9b59b6" strokeWidth="1"/>
        <text x={RP+18} y={H-48} fontSize="11" fill="#9b59b6" fontWeight="700">GCD and LCM from prime factorisations:</text>
        <text x={RP+18} y={H-32} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">gcd: take MIN exponent per prime</text>
        <text x={RP+18} y={H-18} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">lcm: take MAX exponent per prime</text>

      </svg>
      <div style={S.dCaption}>The Sieve of Eratosthenes finds all primes up to n in O(n log log n) by iteratively marking multiples of each prime. The Fundamental Theorem of Arithmetic guarantees every integer greater than 1 has a unique prime factorisation; this underpins GCD and LCM computations (take min/max exponents), the structure of ℤ/nℤ, and the security of RSA encryption. The Prime Number Theorem states π(x) ≈ x/ln(x) — primes thin out but never stop.</div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function SetNumberTheory() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Set Theory and Number Theory in Discrete Mathematics</h1>
      <p style={S.p}>Set theory provides the foundational language of all mathematics: virtually every mathematical object — numbers, functions, relations, graphs — is defined as a set. Georg Cantor's 19th-century discovery that infinite sets come in different sizes (countable vs uncountable) was revolutionary. Number theory, the study of integers and their properties, is one of the oldest branches of mathematics and also one of the most practically important: the security of modern cryptographic systems (RSA, elliptic curve) rests entirely on deep results about prime numbers, modular arithmetic, and the difficulty of factorisation.</p>

      <InfoBox title="Core Ideas: sets as the language of mathematics; integers as the arena of number theory" items={[
        "Set: an unordered collection of distinct elements; A = {1,2,3} — membership written a ∈ A",
        "Set operations: union A∪B, intersection A∩B, difference A\\B, complement A', power set P(A)",
        "Function f: A→B assigns each element of A exactly one element of B (injective/surjective/bijective)",
        "Cardinality: |ℕ|=|ℤ|=|ℚ|=ℵ₀ (countable); |ℝ|=c=2^ℵ₀ (uncountable) — proved by Cantor's diagonal",
        "Divisibility: a|b iff b=ka; gcd via Euclidean algorithm in O(log n); Bézout: gcd(a,b)=sa+tb",
        "Modular arithmetic: a≡b(mod n) iff n|(a-b); rings ℤ/nℤ; fields ℤ/pℤ for prime p; CRT for coprime moduli",
      ]}/>

      <h2 style={S.h2}>Set Operations</h2>
      <DiagramSetOps/>
      <Table2 rows={[
        ["Union A ∪ B",          "Elements in A or B (or both): {x : x∈A or x∈B}\n|A∪B| = |A| + |B| - |A∩B|  (inclusion-exclusion)"],
        ["Intersection A ∩ B",   "Elements in both A and B: {x : x∈A and x∈B}\nA and B are disjoint if A∩B = ∅"],
        ["Difference A \\ B",    "Elements in A but not B: {x : x∈A and x∉B}\nAlso written A - B; not commutative"],
        ["Complement A'",        "All elements of the universe U not in A: U \\ A\n(A')' = A  (double complement is identity)"],
        ["Symmetric difference", "A △ B = (A\\B) ∪ (B\\A) = (A∪B) \\ (A∩B)\nElements in exactly one of A, B; forms a group with ∪"],
        ["Power set P(A)",       "Set of all subsets of A, including ∅ and A itself\n|P(A)| = 2^|A|  (each element either in or out)"],
        ["Cartesian product",    "A × B = {(a,b) : a∈A, b∈B}  (ordered pairs)\n|A×B| = |A|·|B|; relations are subsets of A×B"],
      ]}/>

      <h2 style={S.h2}>Set Identities</h2>
      <DiagramSetIdentities/>
      <Table2 rows={[
        ["De Morgan's laws",     "(A∪B)' = A'∩B'  and  (A∩B)' = A'∪B'\nNegation swaps ∪ and ∩; exactly mirrors Boolean De Morgan"],
        ["Distributive laws",   "A∪(B∩C) = (A∪B)∩(A∪C)\nA∩(B∪C) = (A∩B)∪(A∩C)  — both directions hold"],
        ["Inclusion-exclusion", "|A∪B| = |A|+|B|-|A∩B|\n|A∪B∪C| = |A|+|B|+|C|-|A∩B|-|A∩C|-|B∩C|+|A∩B∩C|"],
        ["Duality principle",   "Every set identity has a dual: swap ∪↔∩ and ∅↔U\nIf a law holds, its dual holds too (mirrors Boolean duality)"],
        ["Partition of a set",  "Sets A₁,...,Aₖ partition A if they are pairwise disjoint\nand their union is A; |A| = |A₁|+...+|Aₖ|"],
        ["Russell's paradox",   "R = {x : x∉x} leads to contradiction\nResolved by axiomatic set theory (ZFC); sets can't contain themselves"],
      ]}/>

      <h2 style={S.h2}>Functions and Relations</h2>
      <DiagramFunctions/>
      <Table2 rows={[
        ["Function f: A→B",      "Assigns each a∈A exactly one f(a)∈B\nDomain=A, codomain=B, range=f(A)⊆B"],
        ["Injective (1-to-1)",   "f(a)=f(b) implies a=b; no two inputs share an output\nNecessary for f to have a left inverse"],
        ["Surjective (onto)",    "For every b∈B there exists a∈A with f(a)=b; range=codomain\nNecessary for f to have a right inverse"],
        ["Bijective",            "Both injective and surjective; perfect pairing\nHas a two-sided inverse f⁻¹: B→A; |A|=|B| for finite sets"],
        ["Composition",          "(g∘f)(x) = g(f(x)); domain of f = domain of g∘f\nAssociative; (g∘f)⁻¹ = f⁻¹∘g⁻¹ for bijections"],
        ["Equivalence relation", "Reflexive (aRa) + Symmetric (aRb→bRa) + Transitive (aRb,bRc→aRc)\nPartitions the set into equivalence classes [a]={b: bRa}"],
        ["Partial order",        "Reflexive + Antisymmetric (aRb and bRa → a=b) + Transitive\nTotal order: every pair is comparable (e.g. ≤ on ℤ)"],
      ]}/>

      <h2 style={S.h2}>Cardinality and Infinity</h2>
      <DiagramCardinality/>
      <Table2 rows={[
        ["Finite cardinality",   "|A| = n means a bijection A→{1,...,n} exists\nAddition/multiplication rules: |A∪B|=|A|+|B| when disjoint"],
        ["Countably infinite",   "A is countably infinite if a bijection A→ℕ exists; cardinality ℵ₀\n|ℕ|=|ℤ|=|ℚ|=ℵ₀ — all countably infinite"],
        ["ℤ is countable",       "Bijection: 0,1,-1,2,-2,3,-3,... maps ℕ onto ℤ\nInterleaving argument shows the same size as ℕ"],
        ["ℚ is countable",       "Cantor's diagonal listing of p/q fractions covers all ℚ\nℚ is dense (between any two rationals is another) yet countable"],
        ["ℝ is uncountable",     "Cantor diagonal: any listing of reals misses a constructed number\n|ℝ|=c=2^ℵ₀ > ℵ₀ — strictly larger than ℕ"],
        ["Cantor's theorem",     "|P(A)| > |A| for any set A (even infinite)\nProved by showing no surjection A→P(A) can exist"],
        ["Continuum hypothesis", "|ℝ| = ℵ₁? (is c the next cardinal after ℵ₀?)\nIndependent of ZFC axioms (Gödel 1940, Cohen 1963)"],
      ]}/>

      <h2 style={S.h2}>Divisibility and the Euclidean Algorithm</h2>
      <DiagramDivisibility/>
      <Table2 rows={[
        ["Divisibility a | b",   "a divides b means ∃k∈ℤ with b=ka\nProperties: a|a;  a|b and b|c → a|c  (transitive)"],
        ["GCD",                  "gcd(a,b) = largest positive integer dividing both\ngcd(a,0) = a;  gcd(a,b) = gcd(b, a mod b)"],
        ["Euclidean algorithm",  "Repeatedly: (a,b) → (b, a mod b) until b=0\nO(log min(a,b)) steps; uses only subtraction and mod"],
        ["Bézout's identity",    "gcd(a,b) = sa+tb for some integers s,t\nFound by back-substituting through Euclidean steps"],
        ["LCM",                  "lcm(a,b) = a·b / gcd(a,b)\ngcd(a,b)·lcm(a,b) = |a·b|"],
        ["Coprime integers",     "gcd(a,b)=1; no common prime factor\nKey: a has multiplicative inverse mod b iff gcd(a,b)=1"],
        ["Linear Diophantine",   "ax+by=c has integer solutions iff gcd(a,b)|c\nGeneral solution built from Bézout coefficients"],
      ]}/>

      <h2 style={S.h2}>Modular Arithmetic</h2>
      <DiagramModular/>
      <Table2 rows={[
        ["Congruence a≡b(mod n)", "n divides (a-b); a and b in same congruence class\nℤ/nℤ has n classes: [0],[1],...,[n-1]"],
        ["Arithmetic in ℤ/nℤ",   "Addition and multiplication well-defined on classes\n(a mod n)+(b mod n) ≡ (a+b) mod n"],
        ["Modular inverse",       "a⁻¹ mod n exists iff gcd(a,n)=1\nFound via extended Euclidean algorithm"],
        ["Fermat's little thm",  "If p prime and p∤a, then a^(p-1) ≡ 1 (mod p)\nUsed in primality testing and RSA decryption"],
        ["Euler's theorem",      "If gcd(a,n)=1 then a^φ(n) ≡ 1 (mod n)\nφ(n) = Euler's totient = count of 1≤k≤n with gcd(k,n)=1"],
        ["Chinese Remainder Thm","Pairwise coprime n₁,...,nₖ: system x≡aᵢ(mod nᵢ)\nhas unique solution mod N=n₁·...·nₖ"],
        ["RSA sketch",           "Public key (e,n), private key d; n=pq, ed≡1(mod φ(n))\nEncrypt: c=m^e mod n;  Decrypt: m=c^d mod n"],
      ]}/>

      <h2 style={S.h2}>Primes and the Fundamental Theorem of Arithmetic</h2>
      <DiagramPrimes/>
      <Table2 rows={[
        ["Prime number",         "Integer p≥2 with no divisors except 1 and p\nComposite: has a factor other than 1 and itself"],
        ["Infinitely many primes","Euclid: suppose p₁,...,pₖ are all primes; N=p₁·...·pₖ+1\nN is divisible by no pᵢ → contradiction; infinitely many primes"],
        ["Sieve of Eratosthenes","Mark all multiples of 2,3,5,7,... up to √n as composite\nO(n log log n) time; O(n) space"],
        ["Fundamental theorem",  "Every n>1 is a product of primes, unique up to order\nProved by strong induction; primes are the 'atoms' of ℤ"],
        ["Prime Number Theorem", "π(x) ~ x/ln(x) as x→∞  (π = prime counting function)\nRiemann hypothesis would sharpen the error term"],
        ["Goldbach's conjecture","Every even integer ≥4 is a sum of two primes\nUnproved since 1742; verified for n up to 4×10¹⁸"],
        ["Primality testing",    "Trial division: O(√n); Miller-Rabin: O(k log²n) probabilistic\nAKS (2002): O(log^6 n) deterministic polynomial-time"],
      ]}/>

      <InfoBox title="Key Takeaway — Set Theory and Number Theory Quick Reference" items={[
        "De Morgan for sets: (A∪B)' = A'∩B' and (A∩B)' = A'∪B' — mirrors Boolean De Morgan exactly",
        "Inclusion-exclusion: |A∪B| = |A|+|B|-|A∩B|; generalises to any number of sets",
        "Bijection ↔ same cardinality; ℕ,ℤ,ℚ are all countable (ℵ₀); ℝ is uncountable (2^ℵ₀)",
        "Euclidean algorithm: gcd(a,b) = gcd(b, a mod b) — O(log n) steps; Bézout gives gcd = sa+tb",
        "a has mod-n inverse iff gcd(a,n)=1; Fermat: a^(p-1) ≡ 1 (mod p) for prime p",
        "CRT: pairwise coprime moduli → unique simultaneous solution; used in RSA and fast arithmetic",
        "Every integer has a unique prime factorisation (FTA); GCD = min exponents, LCM = max exponents",
        "π(x) ≈ x/ln(x) primes up to x; infinitely many primes by Euclid's contradiction argument",
      ]}/>
    </div>
  );
}